import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { handleUpstoxCallback } from '../slices/upstoxAuthSlice';

function UpstoxCallback() {
  const dispatch = useDispatch();
  const location = useLocation();
  const status = useSelector((state) => state.upstoxAuthSlice.status);



  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const code = query.get('code');
    console.log(code);

    if (code) {
      dispatch(handleUpstoxCallback(code));
    }
  }, [dispatch, location]);

  return <div>
    {status === 'succeeded' ? <div>Token Generated Successfully</div> : <div>Succes</div>}
  </div>;
}

export default UpstoxCallback;